export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/greenTick.5b2711b8.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};